import { render, staticRenderFns } from "./OrderControlSection.vue?vue&type=template&id=c47bbb6e&scoped=true"
import script from "./OrderControlSection.vue?vue&type=script&lang=js"
export * from "./OrderControlSection.vue?vue&type=script&lang=js"
import style0 from "./OrderControlSection.vue?vue&type=style&index=0&id=c47bbb6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47bbb6e",
  null
  
)

export default component.exports